<template>
  <div v-loading="loading">
    <Header></Header>
    <div class="main-container">
      <div class="title">欢迎使用中兴新支点操作系统升级订阅服务</div>
      <div class="content">
        <div class="sn-verify">
          <el-input placeholder="请输入序列号" v-model="sn" maxlength="1000"></el-input>
          <el-button type="primary" class="getVerifyCodeButton" @click="handleSnVerifyClick">验 证</el-button>
          <p class="tips">输入序列号进行验证，多个序列号请使用英文逗号“,”分隔</p>
          <div class="sn-check-result">
            <p v-if="snVerifyResult == null"><i class="el-icon-warning-outline"></i> 请点击验证按钮，进行序列号验证</p>
            <p class="success" v-if="snVerifyResult == true"><i class="el-icon-circle-check"></i> 验证成功，序列号有效</p>
            <p class="faild" v-if="snVerifyResult == false"><i class="el-icon-circle-close"></i> 验证失败，序列号无效</p>
          </div>
        </div>
        <div class="email-verify">
          <el-input class="account_input" name="account" type="text" v-model="account" autoComplete="off" placeholder="请输入邮箱" />
          <p class="tips">我们将通过电子邮件的方式，将操作系统的升级补丁信息发送给您</p>
          <el-input class="verify_code_input" v-model="verifyCode" autoComplete="off" placeholder="请输入验证码" />
          <el-button v-if="validator.codeShow" type="primary" class="getVerifyCodeButton" @click="handleGetVerifyCodeClick">获取验证码</el-button>
          <el-button v-if="!validator.codeShow" type="primary" :disabled="true" class="getVerifyCodeButton">{{validator.count}}秒后重试</el-button>
        </div>
        <el-button class="action" type="primary" :disabled="sn == '' || account == '' || verifyCode == ''" @click.native.prevent="verifyOperation">订 阅</el-button>
      </div>
    </div>
    <div>
      <Vcode class="vcode" :show="isShow" @success="vCodeSuccess" @close="vCodeClose" />
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Vcode from "vue-puzzle-vcode";
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import { snVerify, subscribe } from "@/api/subscribe.js";
import { verifyAccount } from "@/api/verifyCode.js";

export default {
  name: "",
  components: {
    Footer,
    Header,
    Vcode,
  },
  props: [""],
  data() {
    return {
      loading: false,
      sn: "",
      snVerifyResult: null,
      vaildSn: [],
      account: "",
      verifyCode: "",
      validator: {
        codeShow: true,
        count: "",
        timer: null,
      },
      isShow: false,
    };
  },

  created() {},

  methods: {
    handleSnVerifyClick() {
      this.vaildSn = [];
      var snArr = this.sn.split(",");
      snArr.forEach((sn) => {
        if (this.checkSnCodeFormat(sn)) {
          this.vaildSn.push(sn.toUpperCase());
        }
      });
      if (this.vaildSn.length < 1) {
        this.$message.error("请输入正确格式的序列号");
      } else {
        let postData = {
          sn: this.vaildSn.join(","),
        };
        snVerify(postData)
          .then((res) => {
            this.snVerifyResult = res.data.data;
          })
          .catch((err) => {});
      }
    },

    /**
     * 获取验证码
     */
    handleGetVerifyCodeClick() {
      if (this.validateEmail(this.account)) {
        const TIME_COUNT = 60;
        if (!this.validator.timer) {
          this.validator.count = TIME_COUNT;
          this.validator.codeShow = false;
          this.validator.timer = setInterval(() => {
            if (
              this.validator.count > 0 &&
              this.validator.count <= TIME_COUNT
            ) {
              this.validator.count--;
            } else {
              this.validator.codeShow = true;
              clearInterval(this.validator.timer);
              this.validator.timer = null;
            }
          }, 1000);

          // 调用发送验证码接口
          let params = {
            account: this.account,
            type: 1,
          };
          verifyAccount(params)
            .then((res) => {
              this.$message.success("验证码发送成功");
            })
            .catch((err) => {
              this.validator.codeShow = true;
              clearInterval(this.validator.timer);
              this.validator.timer = null;
            });
        }
      } else {
        this.$message.error("邮箱地址格式不正确");
      }
    },

    /**
     * 当订阅按钮点击时
     */
    handleSubscribeButtonClick() {
      if (!this.snVerifyResult) {
        this.$message.error("请验证有效序列号");
      } else if (!this.validateEmail(this.account)) {
        this.$message.error("请输入正确的邮箱地址");
      } else if (this.verifyCode == "") {
        this.$message.error("请输入验证码");
      } else {
        this.loading = true;
        let postData = {
          sn: this.vaildSn.join(","),
          account: this.account,
          verifyCode: this.verifyCode,
        };
        subscribe(postData)
          .then((res) => {
            this.$router.push({ name: "Success" });
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
          });
      }
    },

    verifyOperation() {
      this.isShow = true;
    },
    /**
     *用户通过了验证
     */
    vCodeSuccess() {
      this.handleSubscribeButtonClick();
      // 通过验证后，需要手动隐藏模态框
      this.isShow = false;
    },
    /**
     * 用户点击遮罩层，应该关闭模态框
     */
    vCodeClose() {
      this.isShow = false;
    },

    /**
     * validate email
     * @param email
     * @returns {boolean}
     */
    validateEmail(email) {
      const re = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      return re.test(email);
    },
    /**
     * 序列号正则表达式验证
     */
    checkSnCodeFormat(data) {
      const reg =
        /^[0-9A-Za-z]{4}-[0-9A-Za-z]{4}-[0-9A-Za-z]{4}-[0-9A-Za-z]{4}$/;
      return reg.test(data);
    },
  },
};
</script>
<style lang='scss' scoped>
// PC
@media screen and (min-width: 992px) {
  .main-container {
    height: calc(100vh - 254px - 60px);
    min-height: 600px;
    overflow: auto;

    .title {
      height: 60px;
      line-height: 60px;
      font-size: 30px;
      letter-spacing: 2px;
      color: #333;
      margin: 60px 0 30px 0;
    }

    .content {
      height: 400px;
      width: 800px;
      margin: auto;
      p {
        padding: 0;
        margin: 0;
      }

      .tips {
        text-align: left;
        padding-left: 2px;
        padding-top: 5px;
        color: rgb(131, 131, 131);
      }

      .sn-verify {
        .el-input {
          width: 720px;
        }

        .sn-check-result {
          margin-top: 30px;
          p {
            color: #333;
          }
          .success {
            color: #67c23a;
          }
          .faild {
            color: #f56c6c;
          }
        }
      }

      .email-verify {
        .account_input {
          width: 800px;
          margin-top: 40px;
        }

        .verify_code_input {
          width: 680px;
          margin: 40px 0;
        }
      }
    }
  }
}

// mobile
@media screen and (max-width: 990px) {
  .main-container {
    height: calc(100vh - 254px);
    .title {
      font-size: 18px;
      color: #333;
      padding: 30px 0px;
    }

    .content {
      height: 400px;
      margin: auto;
      padding: 10px 10px 30px 10px;
      box-sizing: border-box;
      p {
        padding: 0;
        margin: 0;
      }

      .tips {
        font-size: 14px;
        text-align: left;
        padding-left: 2px;
        padding-top: 5px;
        color: rgb(131, 131, 131);
      }

      .sn-verify {
        .el-input {
          width: calc(100% - 110px);
        }

        .el-button {
          width: 105px;
        }

        .sn-check-result {
          margin-top: 15px;
          p {
            color: #333;
          }
          .success {
            color: #67c23a;
          }
          .faild {
            color: #f56c6c;
          }
        }
      }

      .email-verify {
        .account_input {
          width: 100%;
          margin-top: 30px;
        }

        .verify_code_input {
          width: calc(100% - 110px);
          margin: 20px 0;
        }

        .el-button {
          width: 105px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index.vue